import React from 'react';
import { Box, Typography } from '@mui/material';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import BookingCard from './BookingCard/BookingCard';
import { useAppSelector } from '../../../redux/hooks';
import { formatDate } from '../../../utils/utils';
import EmptyBookingCard from './EmptyBookingCard/LoadingBookingCard';
import EmptyBookings from './EmptyBookingCard/EmptyBookings';

const StyledBox = styled(Box)(() => ({
  maxHeight: '80%',
  backgroundColor: '#fff',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  borderRadius: '10px',
}));

const BookingCardsWrapper = () => {
  const bookings = useAppSelector((state) => state.booking.bookings);
  const selectedDate = useAppSelector((state) => state.booking.selectedDate);
  const {
    i18n: { language },
  } = useTranslation();
  const loading = useAppSelector((state) => state.booking.fetchBookingsLoading);

  const filteredBookings = bookings.filter(
    (booking) => new Date(booking.date).getDate() === new Date(selectedDate).getDate()
  );

  // order bookings by time
  filteredBookings.sort((a, b) => dayjs(a.date).unix() - dayjs(b.date).unix());

  return (
    <Box sx={{ borderRadius: '10px', backgroundColor: '#fff', height: '100%' }}>
      <Box>
        <Typography
          variant="h4"
          sx={{
            padding: '16px 24px 16px 16px',
            position: 'relative',
            '::after': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '1px',
              backgroundColor: '#7CAEBE',
              transform: 'scaleY(0.5)',
            },
          }}
        >
          {formatDate(selectedDate, language)}
        </Typography>
      </Box>

      {!loading && filteredBookings.length === 0 ? (
        <StyledBox sx={{ padding: '20px', textAlign: 'center' }}>
          <EmptyBookings />
        </StyledBox>
      ) : (
        <StyledBox>
          {!loading &&
            filteredBookings.map((booking, _index) => (
              <BookingCard key={booking.id} booking={booking} />
            ))}
          {loading && (
            <Box>
              <EmptyBookingCard />
              <EmptyBookingCard />
            </Box>
          )}
        </StyledBox>
      )}
    </Box>
  );
};

export default BookingCardsWrapper;
